(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function closestPanel(node) {
    return node && node.closest('[class*="tz-right-pane-"]');
  }

  function initReviewJump() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-tz-review-jump]');
      if (!trigger) return;
      var target = document.querySelector('#shopify-block-alireviews, [id*="alireviews"], .alr-wh-star-rating, .alireviews-review-box, [data-ali-reviews]');
      if (!target) return;
      event.preventDefault();
      var offset = parseInt(trigger.getAttribute('data-scroll-offset') || '90', 10);
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    });
  }

  function initVideoShortcut() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[id^="tz-watch-video-btn-"]');
      if (!button) return;
      var panel = button.closest('[class*="tz-left-pane-"]') || document;
      var videoSlide = panel.querySelector('[data-media-holder], .video__holder, .external__holder');
      if (!videoSlide) return;
      videoSlide.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var video = videoSlide.querySelector('video');
      if (video && video.paused) {
        video.play().catch(function () {});
      }
    });
  }

  function initAccordions() {
    document.addEventListener('click', function (event) {
      var header = event.target.closest && event.target.closest('.tz-premium-faq-row, .tz-info-tab-button, [data-tz-accordion-trigger]');
      if (!header || !closestPanel(header)) return;
      var expanded = header.getAttribute('aria-expanded');
      if (expanded === null) return;
      header.setAttribute('aria-expanded', expanded !== 'true' ? 'true' : 'false');
    });
  }

  function initMediaState() {
    document.addEventListener('click', function (event) {
      var thumb = event.target.closest && event.target.closest('.gallery__thumbnail');
      if (!thumb) return;
      var allThumbs = thumb.parentNode ? thumb.parentNode.querySelectorAll('.gallery__thumbnail') : [];
      allThumbs.forEach(function (item) {
        item.setAttribute('aria-current', item === thumb ? 'true' : 'false');
      });
    });
  }

  ready(function () {
    initReviewJump();
    initVideoShortcut();
    initAccordions();
    initMediaState();
    document.documentElement.classList.add('tz-product-system-ready');
  });
})();
